module.exports = __webpack_public_path__ + "static/media/PM98.52c1c22f.png";